import { FC } from 'react'
import { Button, ButtonGroup, ButtonProps } from '@material-ui/core'

interface ChoiceProps {
  labels: string[]
  options: any[]
  onChange: (v: any) => void
  value: any
}

export const Choice: FC<ChoiceProps> = ({ options, onChange, value, labels }) => {
  if (options.length === 0 && labels.length === 1) {
    // single true/false choice
    return (
      <ButtonGroup disableElevation variant="outlined" size="small">
        <ToggleButton selected={value} onClick={() => onChange(null)}>
          {labels[0]}
        </ToggleButton>
      </ButtonGroup>
    )
  }

  return (
    <ButtonGroup disableElevation variant="outlined" size="small">
      {options.map((op, i) => (
        <ToggleButton selected={value === op} onClick={() => onChange(op)} key={op}>
          {labels[i]}
        </ToggleButton>
      ))}
    </ButtonGroup>
  )
}

const ToggleButton: FC<{ selected: boolean } & ButtonProps> = ({ selected, ...rest }) => {
  if (selected) {
    return <Button {...rest} variant="contained" color="primary" />
  } else {
    return <Button {...rest} />
  }
}
